import { Cubit } from "blac";
import reportErrorSentry from "src/lib/reportErrorSentry";
import LoadingCubit, { LoadingKey } from "src/state/LoadingCubit/LoadingCubit";
import { DeviceControllerService } from "@9amhealth/openapi";
import type { DeviceItem } from "@9amhealth/openapi";
import { Blac } from "blac-next";
import { onUserSessionReset } from "src/lib/onUserSessionReset";

interface DevicesState {
  devices: DeviceItem[];
}
export default class DevicesCubit extends Cubit<DevicesState> {
  constructor() {
    super({
      devices: []
    });

    onUserSessionReset(() => this.emit({ devices: [] }));
  }

  public readonly getUserDevices = async () => {
    const loadingState = Blac.getBloc(LoadingCubit);
    loadingState.start(LoadingKey.devices);
    try {
      const response = await DeviceControllerService.findUserDevices();
      this.emit({
        ...this.state,
        devices: response.data
      });
    } catch (error) {
      reportErrorSentry(error);
    }
    loadingState.finish(LoadingKey.devices);
  };
}
